// extracted by mini-css-extract-plugin
export default {"container":"LastEventPage_container__K1D+1","gradientBackground":"LastEventPage_gradientBackground__VsibT","comingSoon":"LastEventPage_comingSoon__e1sf6"};